interface CategoryBadgeProps {
  label: string;
  count?: number;
  onClick?: () => void;
}

export default function CategoryBadge({
  label,
  count,
  onClick,
}: CategoryBadgeProps) {
  return (
    <button
      onClick={onClick}
      className="px-4 py-2 rounded-full bg-white/10 hover:bg-white/20 text-white text-sm font-medium transition-colors"
    >
      {label}
      {count !== undefined && (
        <span className="ml-2 text-white/70">({count})</span>
      )}
    </button>
  );
} 